/*
 * @Description:审批代理
 * @Autor: lwq
 * @Date: 2020-07-29 09:48:51
 * @LastEditors: yd
 * @LastEditTime: 2020-10-10 10:37:23
 * @FilePath: \mrc-base-server-view\src\service\api\costCenter.js
 */

import http from '../httpConfig'

const table = "mrbase_sys_cost_center"

// 列表
export const costCenterList = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/cost_center/list-center/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 新增
export const addCostCenter = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/cost_center/add-center/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 删除
export const delCostCenter = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/cost_center/delect-center/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 修改
export const updateCostCenter = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/cost_center/update-center/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 详情
export const detailCostCenter = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/cost_center/find-center/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}